// Build-time feature flags. multiStoreOrdering stays off everywhere until the
// flow is verified in dev (set VUE_APP_MULTI_STORE_ORDERING=true in .env.dev).
export const multiStoreOrdering = process.env.VUE_APP_MULTI_STORE_ORDERING === 'true'
